module.exports = __webpack_public_path__ + "img/download-tile-bg-mobile__en.f63fb16.jpg";